import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

import { SUPPORT_EMAIL } from "@/constants";
import { env } from "@/env";

const contactBarVariants = tv({
  slots: {
    container: "rounded-t-lg bg-success p-3 text-center text-lg font-bold text-success-content",
  },
});

const { container } = contactBarVariants();

export const ContactBar = ({ className, ...props }: ComponentProps<"div">) => {
  return (
    <div className={container({ className })} {...props}>
      Questions? Call{" "}
      <a href={`tel:${env.VITE_EO_CONTACT_NUMBER}`}>{env.VITE_EO_CONTACT_NUMBER}.</a> or email{" "}
      <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}.</a>
    </div>
  );
};
